// extracted by mini-css-extract-plugin
export default {"modalFooterButtons":"ProductMeasureEditionModal_modalFooterButtons__ScXzA"};